var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "flex flex-col justify-center items-center w-full bg-white h-auto rounded-lg"
  }, [_c('div', {
    staticClass: "flex flex-col text-center justify-center items-center w-full px-10"
  }, [_c('div', {
    staticClass: "flex mb-1 justify-center items-center text-center w-full px-10"
  }, [_c('img', {
    staticClass: "w-5 h-5",
    attrs: {
      "src": require('@/assets/img/spinner.svg')
    }
  })]), _c('div', [_c('label', {
    staticClass: "text-gray-700 text-base font-semibold mb-2"
  }, [_vm._v(" " + _vm._s(_vm.fileName) + " ")])]), _c('div', {
    staticClass: "text-center text-xs font-normal my-2"
  }, [_vm._v(" " + _vm._s(_vm.statusText) + " ")]), _c('div', {
    staticClass: "h-2 bg-gray-200 rounded-full w-full"
  }, [_c('div', {
    staticClass: "bg-blue-500 h-2 rounded-full transition-all duration-300",
    style: {
      width: _vm.progress + '%'
    }
  })]), _c('div', {
    staticClass: "text-center text-xs font-normal text-gray-500 my-2"
  }, [_vm._v(" " + _vm._s(_vm.progress) + "% ")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }